import { Card } from 'antd';
import styled from 'styled-components';

export const TasksCard = styled(Card)`
  .ant-card-body {
    height: calc(100vh - 230px);
    overflow: auto;
    display: flex;
    flex-direction: column;
  }
`;
